export default "__VITE_ASSET__DYvbQ3SW__"